import { useEffect, useState } from 'react';

export interface OaddEligibleDealer {
  dealerName: string;
  dealerId: string;
  rootUrl: string;
  vehicleUrl: string;
  market: string;
  isTier3: boolean;
}

const isDealer = (obj: any): obj is OaddEligibleDealer => {
  return (
    typeof obj?.dealerName === 'string' &&
    typeof obj?.dealerId === 'string' &&
    typeof obj?.rootUrl === 'string' &&
    typeof obj?.vehicleUrl === 'string' &&
    typeof obj?.market === 'string' &&
    typeof obj?.isTier3 === 'boolean'
  );
};

export const useGetOaddDealers = (cdnUrl: string, isTier3: boolean) => {
  const [dealers, setDealers] = useState<OaddEligibleDealer[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isTier3) {
      setDealers([]);
      return;
    }

    const fetchDealers = async () => {
      try {
        setLoading(true);
        const response = await fetch(cdnUrl);

        if (!response.ok) {
          throw new Error(`Failed to fetch: ${response.status}`);
        }

        const data: unknown = await response.json();

        if (Array.isArray(data)) {
          // Filter out invalid entries
          const validDealers = data.filter(isDealer);
          setDealers(validDealers);
        } else {
          throw new Error('Invalid JSON format (expected array)');
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDealers();
  }, [cdnUrl, isTier3]);

  return { eligibleOaddDealers: dealers, loading, error };
};
